import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { AuthService } from "./auth.service";
import { SnackBarService } from "../shared/snack-bar/application/snack-bar.service";
import { UserRoleName } from "./auth.model";
import { AlertType } from "../shared/snack-bar/domain/snack-bar.model";
import { TranslateService } from '@ngx-translate/core';

export const userRoleGuard = (...roles: UserRoleName[]): CanActivateFn => {
  return () => {
    const authService = inject(AuthService);
    const snackBarService = inject(SnackBarService);
    const translateService = inject(TranslateService);
    const router = inject(Router);

    const hasPermission: boolean = !!authService.account()?.userHasOneOfPermission(roles);

    if (!hasPermission) {
      snackBarService.open({
        message: translateService.instant("errors.unauthorized"),
        type: AlertType.error,
      });
      router.navigateByUrl(router.url);
    }

    return hasPermission;
  };
};
